/**
 * The builder's first step — the prebuilt-vs-custom door picker. Presentation
 * only: it renders the two funnel doors from {@link BUILDER_CHOICES} and calls
 * back with the chosen one; the pure {@link builderDestination} routing + the
 * parent own what each door does (prebuilt → free account setup, custom → billing
 * first). A new door is a new {@link BuilderChoiceOption} row, never a fork here.
 */
import { Button, useT } from '@4f/ui';
import { For, type JSX } from 'solid-js';
import { BUILDER_CHOICES, type BuilderChoice } from './builder-picker.ts';

export interface BuilderPickerProps {
  /** Called with the chosen funnel door. */
  onChoose(choice: BuilderChoice): void;
}

export function BuilderPicker(props: BuilderPickerProps): JSX.Element {
  const { t } = useT();

  return (
    <section class="f4-builder-picker" aria-label={t('builder.picker.legend')}>
      <p class="f4-genui__prompt">{t('builder.picker.legend')}</p>
      <div class="f4-builder-picker__grid">
        <For each={BUILDER_CHOICES}>
          {(option) => (
            <article class="f4-builder-picker__card">
              <span class="f4-builder-picker__badge" data-free={option.free ? 'true' : 'false'}>
                {t(option.badgeKey)}
              </span>
              <h3 class="f4-builder-picker__title">{t(option.titleKey)}</h3>
              <p class="f4-builder-picker__blurb">{t(option.blurbKey)}</p>
              <Button
                type="button"
                variant={option.free ? 'primary' : 'ghost'}
                onClick={() => props.onChoose(option.choice)}
              >
                {t(option.ctaKey)}
              </Button>
            </article>
          )}
        </For>
      </div>
    </section>
  );
}
